import Vue from 'vue'
import ZoomOnHover from 'vue-zoom-on-hover'
Vue.use(ZoomOnHover)
